import 'zone.js'
import './preload'

import { enableProdMode, NgModuleRef, provideZoneChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap'

import { BootstrapDataFromJSON } from 'elements-sdk'
import { LoggerFactory } from 'common/log'
import { isTouchDevice } from 'common/helpers'

import { AppModule } from './root/app.module'
import { BOOTSTRAP_DATA } from './api'

const failBootstrap = (error) => {
  console.error(error)
  const e = document.getElementById('angular-bootstrap-error')!
  e.style.display = 'block'
  e.querySelector('code')!['innerText'] = error.constructor?.name
  e.querySelector('pre.a')!['innerText'] = error.message
}

window['bootstrapData']
  .then(async (bootstrapData) => {
    const style = 'background: yellow; width: 20px; height: 20px; display: inline-block;'
    const reset = 'background: transparent;'
    console.log(
      '  %c    \n%c  \n%c  %c    \n%c  \n%c  %c    ',
      style,
      style,
      reset,
      style,
      style,
      reset,
      style,
    )

    const logger = new LoggerFactory().create('entry')

    logger.group(`Welcome to ELEMENTS ${bootstrapData.version.release}`)
    console.log('https://elements.tv')
    console.log('service@elements.tv')
    console.log('')
    console.log(
      '💡 Check out our SDK: https://python.sdk.elements.tv/ and the API playground in your Profile > API > Playground',
    )
    console.log('Or take a peek in the Network tab - it\'s all the same thing.')
    logger.groupEnd()

    if (bootstrapData.license?.expiry) {
      bootstrapData.license.expiry = new Date(bootstrapData.license.expiry)
    }

    window['debug'] = bootstrapData.debug
    if (!bootstrapData.debug) {
      enableProdMode()
    }

    let mod: NgModuleRef<AppModule>
    try {
      mod = await platformBrowserDynamic([
        { provide: BOOTSTRAP_DATA, useValue: BootstrapDataFromJSON(bootstrapData) },
      ]).bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    } catch (error) {
      failBootstrap(error)
      throw error
    }

    if (window.isSecureContext) {
      try {
        await navigator.serviceWorker.register('/serviceWorker.js?v=' + window['cachebust'])
      } catch (error) {
        console.warn('Could not install the Service Worker:', error)
      }
    }

    if (isTouchDevice()) {
      document.body.parentElement!.classList.add('mobile-mode')
    }

    mod.injector.get(NgbTooltipConfig).disableTooltip = isTouchDevice()
  })
  .catch((error) => {
    failBootstrap(error)
  })
